import "./filter.scss";

import PropTypes from "prop-types";
import React, { Fragment } from "react";

import Icon from "../../components/interface/Icon";
import keyConstants from "../../constants/keyConstants";
import { PropTypeShapes } from "../../types";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";

const clickWasClear = e => hasAncestorOfClass(e.target, "clearIcon");
const enterWasClear = e =>
  e.target.querySelectorAll(":scope > .clearIcon").length || e.target.querySelectorAll(":scope > .clearBtn").length;

const onKeyDown = (e, onToggle, onClear) => {
  let keyHandled = false;

  switch (e.key) {
    case keyConstants.Enter: {
      if (enterWasClear(e)) {
        onClear(e);
      } else {
        onToggle(e);
      }
      keyHandled = true;
      break;
    }
  }

  if (keyHandled) {
    e.stopPropagation();
    e.preventDefault();
  }
};

const renderRemoveableHeader = useProps => {
  const arrowIcon = useProps.isActive ? (useProps.isCollapsed ? "rightArrow" : "downArrow") : "";
  return (
    <div
      className="filterGroupHeading clearable"
      tabIndex={useProps.disabled ? -1 : 0}
      onKeyDown={e =>
        onKeyDown(e, useProps.onToggleCollapse, useProps.isActive ? useProps.onClear : useProps.onClearAndClose)
      }
    >
      <Icon
        className="toggleIcon"
        icon={arrowIcon}
        color="iconBold"
        onClick={arrowIcon ? useProps.onToggleCollapse : null}
      />
      <span>{useProps.label}</span>
      {useProps.isActive ? (
        <div onClick={useProps.onClear} tabIndex={useProps.disabled ? -1 : 0}>
          <span className="clearBtn">Clear</span>
        </div>
      ) : (
        <Icon className="clearIcon" icon="listDelete" color="iconBold" onClick={useProps.onClearAndClose} />
      )}
    </div>
  );
};

const renderNonRemoveableHeader = useProps => (
  <div
    className="filterGroupHeading nonClearable"
    onClick={e => (clickWasClear(e) ? null : useProps.onToggleCollapse())}
    tabIndex={useProps.disabled ? -1 : 0}
    onKeyDown={e => onKeyDown(e, useProps.onToggleCollapse, useProps.onClear)}
  >
    <Icon className="toggleIcon" icon={useProps.isCollapsed ? "rightArrow" : "downArrow"} color="iconBold" />
    <span>{useProps.label}</span>
    {useProps.isActive ? (
      <div onClick={useProps.onClear} tabIndex={useProps.disabled ? -1 : 0}>
        <span className="clearBtn">Clear</span>
      </div>
    ) : null}
  </div>
);

const FilterGroup = props => (
  <Fragment>
    {props.isActive || !props.isCollapsed || props.alwaysShowHeader ? (
      <div
        className={`filterGroup ${props.disabled ? "disabled" : ""} ${props.isCollapsed ? "collapsed" : ""} ${
          props.isActive ? "active" : "inactive"
        }`}
        onClick={props.isCollapsed ? props.onToggleCollapse : null}
      >
        {props.alwaysShowHeader ? renderNonRemoveableHeader(props) : renderRemoveableHeader(props)}
        {props.isCollapsed && props.isActive ? <span className="filterSubLabel">{props.subLabel}</span> : null}
        {props.isCollapsed ? null : props.children}
      </div>
    ) : null}
  </Fragment>
);

FilterGroup.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  isActive: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  onClear: PropTypes.func,
  onClearAndClose: PropTypes.func,
  onToggleCollapse: PropTypes.func,
  alwaysShowHeader: PropTypes.bool
};

export default FilterGroup;
